import { atom } from 'jotai';

export const contractIdAtom = atom<string | null>(null);
